import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'src/registry/ui/Checkbox';
import { FormControl, FormControlStack, FormField, FormItem, FormLabel } from 'src/registry/ui/Form';
import { MembershipTypeFormSchemaValues } from 'src/features/membershipType/formSchema';

const CheckboxFormField = ({
    form,
    fieldName,
    title,
    resetFieldNames,
    disabled = false,
}: {
    form: UseFormReturn<MembershipTypeFormSchemaValues>;
    fieldName: keyof MembershipTypeFormSchemaValues;
    title: { id: string; defaultMessage: string };
    disabled?: boolean;
    resetFieldNames?: string[];
}) => {
    return (
        <FormField
            control={form.control}
            name={fieldName}
            render={({ field }) => (
                <FormItem variant="dialog">
                    <FormLabel variant="dialog">
                        <FormattedMessage {...title} />
                    </FormLabel>
                    <FormControlStack>
                        <FormControl>
                            <Checkbox
                                disabled={disabled}
                                checked={!!field.value}
                                onCheckedChange={(checked) => {
                                    const value = checked === true;
                                    field.onChange(value);

                                    if (!value) {
                                        resetFieldNames?.map((field) => {
                                            const fieldSetValue =
                                                field === 'duration' ||
                                                field === 'duration_unit' ||
                                                field === 'max_allowed_spaces_count'
                                                    ? null
                                                    : false;
                                            form.setValue(
                                                field as keyof MembershipTypeFormSchemaValues,
                                                fieldSetValue,
                                                {
                                                    shouldValidate: true,
                                                    shouldDirty: true,
                                                },
                                            );
                                        });
                                    }
                                }}
                            />
                        </FormControl>
                    </FormControlStack>
                </FormItem>
            )}
        />
    );
};

export default CheckboxFormField;
